import React, { useState } from "react";
import {
  Box,
  Modal,
  Typography,
  TextField,
  Button,
  Grid,
  useTheme,
  InputLabel,
  Snackbar,
  Alert,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import emailjs from "emailjs-com";
const SERVICE_ID = "service_4pgbvrk";
const TEMPLATE_ID = "template_yqvq34f";
const PUBLIC_KEY = "Tz84m2vlFDNC91fWv";
const SubscribeModal = ({ open, onClose }) => {
  const theme = useTheme();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [emailError, setEmailError] = useState({
    error: false,
    helperText: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error", // can be 'success' or 'error'
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (e.target.name === "email") {
      setEmailError({ error: false, helperText: "" });
    }
  };
  const handleSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!form.firstName || !form.lastName || !form.email) {
      setSnackbar({
        open: true,
        message: "All fields are required.",
        severity: "error",
      });
      return;
    }
    if (!emailRegex.test(form.email)) {
      setEmailError({
        error: true,
        helperText: "Please enter a valid email address.",
      });
      return;
    }
    setEmailError({ error: false, helperText: "" });
    setLoading(true);
    try {
      const result = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          first_name: form.firstName,
          last_name: form.lastName,
          user_email: form.email,
        },
        PUBLIC_KEY
      );

      console.log("EmailJS Success:", result.text);

      setSnackbar({
        open: true,
        message: "Successfully subscribed!",
        severity: "success",
      });

      setForm({ firstName: "", lastName: "", email: "" });

      setTimeout(() => {
        onClose();
      }, 1500);
    } catch (error) {
      console.error("EmailJS Error:", error);
      setSnackbar({
        open: true,
        message: "Failed to send email. Please try again.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            px: 2,
          }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: 4,
              width: "100%",
              maxWidth: 500,
              px: 4,
              py: 4,
              outline: "none",
              boxShadow: 24,
              position: "relative",
            }}
          >
            {/* Close Icon */}
            <IconButton
              onClick={onClose}
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                color: theme.palette.primary.main,
                border: `1px solid ${theme.palette.primary.main}`,
                p: 0.5,
              }}
            >
              <CloseIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                mb: 3,
                fontWeight: 700,
                color: theme.palette.primary.main,
                fontFamily: theme.fonts?.secondary || "inherit",
              }}
            >
              SUBSCRIBE TO NEWSLETTER
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <InputLabel>
                  <Typography variant="body2">First Name</Typography>
                </InputLabel>
                <TextField
                  fullWidth
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputLabel>
                  <Typography variant="body2">Last Name</Typography>
                </InputLabel>
                <TextField
                  fullWidth
                  name="lastName"
                  value={form.lastName}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel>
                  <Typography variant="body2">Email Address</Typography>
                </InputLabel>
                <TextField
                  fullWidth
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  placeholder="tobi@gmail.com"
                  error={emailError.error}
                  helperText={emailError.helperText}
                />
              </Grid>
            </Grid>
            <Button
              variant="containedPrimary"
              fullWidth
              onClick={handleSubmit}
              sx={{ mt: 4, py: 1.5 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={22} /> : "Confirm Subscription"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};
export default SubscribeModal;